// extracted by mini-css-extract-plugin
export default {"mediumText":"styles_mediumText__CKd8X"};